import React from 'react'
import injectStyles from 'react-jss'

const styles = {
  dropTarget: {
    height: 60,
    backgroundColor: '#effbff',
    border: '2px dashed lightblue',
    //marginTop: 15,
    //marginBottom: 15,
  }
}

const DropTarget = ({ classes }) => <div className={classes.dropTarget} />

export default injectStyles(styles)(DropTarget)


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/FieldsRenderer/DropTarget.js